import React from 'react';

import { MainLayout } from '@/layout/MainLayout';

type IndexChildRoute = { index: true; redirect: string; path?: never; element?: never };
type RegularChildRoute = {
  index?: false;
  path: string;
  element: React.ReactNode;
  redirect?: never;
};
export type ChildRoute = IndexChildRoute | RegularChildRoute;

export type RouteEntry = {
  path: string;
  element: React.ReactNode;
  children?: ChildRoute[];
};

type RouteGroup = {
  Layout: React.FC<{ children: React.ReactNode }>;
  routes: RouteEntry[];
};

import { PublicLayout } from '../layout/PublicLayout';
import { BrandsPage } from '../pages/Brands/BrandsPage';
import { CreateBrandPage } from '../pages/Brands/CreateBrandPage';
import { EditBrandPage } from '../pages/Brands/EditBrandPage';
import { CategoriesPage } from '../pages/Categories/CategoriesPage';
import { CreateCategoryPage } from '../pages/Categories/CreateCategoryPage';
import { EditCategoryPage } from '../pages/Categories/EditCategoryPage';
import { Dashboard } from '../pages/Dashboard';
import { ForgotPasswordPage } from '../pages/ForgotPasswordPage';
import { CreateHeroSlidePage } from '../pages/HeroSlides/CreateHeroSlidePage';
import { EditHeroSlidePage } from '../pages/HeroSlides/EditHeroSlidePage';
import { HeroSlidesPage } from '../pages/HeroSlides/HeroSlidesPage';
import { LoginPage } from '../pages/LoginPage';
import { OrdersPage } from '../pages/Orders/OrdersPage';
import { OrderViewPage } from '../pages/Orders/OrderViewPage';
import { CreateProductPage } from '../pages/Products/CreateProductPage';
import { EditProductPage } from '../pages/Products/EditProductPage';
import { ProductsPage } from '../pages/Products/ProductsPage';
import { ProductViewPage } from '../pages/Products/ProductViewPage';
import { ResetPasswordPage } from '../pages/ResetPasswordPage';
import { ContactsSettingsPage } from '../pages/Settings/ContactsSettingsPage';
import { SecuritySettingsPage } from '../pages/Settings/SecuritySettingsPage';
import { UsersPage } from '../pages/Users/UsersPage';
import { UserViewPage } from '../pages/Users/UserViewPage';

import { ROUTES } from './routes';

export const routesConfig: RouteGroup[] = [
  {
    Layout: MainLayout,
    routes: [
      {
        path: ROUTES.DASHBOARD,
        element: <Dashboard />,
      },
      {
        path: ROUTES.PRODUCT_CREATE,
        element: <CreateProductPage />,
      },
      {
        path: ROUTES.PRODUCTS,
        element: <ProductsPage />,
      },
      {
        path: ROUTES.PRODUCT_EDIT,
        element: <EditProductPage />,
      },
      {
        path: ROUTES.PRODUCT_VIEW,
        element: <ProductViewPage />,
      },
      {
        path: ROUTES.BRAND_CREATE,
        element: <CreateBrandPage />,
      },
      {
        path: ROUTES.BRANDS,
        element: <BrandsPage />,
      },
      {
        path: ROUTES.BRAND_EDIT,
        element: <EditBrandPage />,
      },
      {
        path: ROUTES.CATEGORY_CREATE,
        element: <CreateCategoryPage />,
      },
      {
        path: ROUTES.CATEGORIES,
        element: <CategoriesPage />,
      },
      {
        path: ROUTES.CATEGORY_EDIT,
        element: <EditCategoryPage />,
      },
      {
        path: ROUTES.HERO_SLIDE_CREATE,
        element: <CreateHeroSlidePage />,
      },
      {
        path: ROUTES.HERO_SLIDES,
        element: <HeroSlidesPage />,
      },
      {
        path: ROUTES.HERO_SLIDE_EDIT,
        element: <EditHeroSlidePage />,
      },
      {
        path: ROUTES.ORDERS,
        element: <OrdersPage />,
      },
      {
        path: ROUTES.ORDER_VIEW,
        element: <OrderViewPage />,
      },
      {
        path: ROUTES.USERS,
        element: <UsersPage />,
      },
      {
        path: ROUTES.USER_VIEW,
        element: <UserViewPage />,
      },
      {
        path: ROUTES.SETTINGS,
        element: null,
        children: [
          { index: true, redirect: ROUTES.SETTINGS_CONTACTS },
          { path: 'contacts', element: <ContactsSettingsPage /> },
          { path: 'security', element: <SecuritySettingsPage /> },
        ],
      },
    ],
  },
  {
    Layout: PublicLayout,
    routes: [
      {
        path: ROUTES.LOGIN,
        element: <LoginPage />,
      },
      {
        path: ROUTES.FORGOT_PASSWORD,
        element: <ForgotPasswordPage />,
      },
      {
        path: ROUTES.RESET_PASSWORD,
        element: <ResetPasswordPage />,
      },
    ],
  },
];
